import { render, staticRenderFns } from "./OrderVolumePerManufacturerReport.vue?vue&type=template&id=5d1884e3"
import script from "./OrderVolumePerManufacturerReport.vue?vue&type=script&lang=ts"
export * from "./OrderVolumePerManufacturerReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports